module.exports = __webpack_public_path__ + "media/images/gift-img-disabled-d9d3ba418a82d67436c8d4d10c838420.png";